export default __webpack_public_path__ + "static/media/5.76da4dd7.webp";